import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Button, ButtonGroup, Card, CircularProgress, Grid, Hidden, Typography } from '@material-ui/core';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Label, ComposedChart } from 'recharts';
import { PieChart, Pie, Sector, LabelList } from 'recharts';
import { Wifi } from '@material-ui/icons';
import './mainDashboard.scss';
import { useHistory } from 'react-router-dom';
import { SecondaryButton } from '../FormInput';
import { useWindowSize } from '../Controls/ScreenResolution';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { EWipDashProvider, EWIPDashboardScreenContext } from './DashboardProvider';
import WipDashboardDates from './DashboardTemplates/wipDash-Dates';
import WipDashboardBranch from './DashboardTemplates/wipDash-Branch';
import { WipDashboardStatus } from './DashboardTemplates/wipDash-Status';
import { WipDashboardWorkflow } from './DashboardTemplates/wipDash-Workflow';
import { WipDashboardHours } from './DashboardTemplates/wipDash-Hours';
import { WipDashboardReturnReason } from './DashboardTemplates/wipDash-returnReason';
import { WipDashboardTechnician } from './DashboardTemplates/wipDash-Technician';
import WipDashboardInspectionCount from './DashboardTemplates/wipDash-InspectionCount';
import WipDashboardAllInspectionCount from './DashboardTemplates/wipDash-AllInspectioncount';

const DashboardCharts = (props) => {
    return (
        <Grid item container alignContent="flex-start" style={{ overflow: 'auto', height: 'calc(100vh - 235px)' }} className="custom-scroll">
            {/* *****************Branch************** */}
            <Grid item container xs={12} sm={12} md={12} lg={4} xl={3} style={{ padding: 5 }}>
                <WipDashboardBranch onChartClickHandler={props.onChartClickHandler} />
            </Grid>
            {/* *****************Date************** */}
            <Grid item container xs={12} sm={12} md={12} lg={8} xl={9} style={{ padding: 5, boxSize: 'none' }}>
                <WipDashboardDates onChartClickHandler={props.onChartClickHandler} />
            </Grid>
            {/* *****************All Inspection************** */}
            {/* <Grid item container xs={12} sm={12} md={12} lg={4} xl={3} style={{ padding: 5 }}>
                <WipDashboardAllInspectionCount onChartClickHandler={props.onChartClickHandler} />
            </Grid> */}
            {/* *****************Inspection Count************** */}
            {/* <Grid item container xs={12} sm={12} md={12} lg={8} xl={9} style={{ padding: 5, boxSize: 'none' }}>
                <WipDashboardInspectionCount inspectionListCounts={props.state.inspectionListCounts} />
            </Grid> */}
            {/* *****************Status************** */}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container style={{ padding: 5, boxSize: 'none' }}>
                <WipDashboardStatus HandleStatusLink={props.HandleStatusLink} />
            </Grid>
            {/* *****************Hours************** */}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container style={{ padding: 5, boxSize: 'none' }}>
                <WipDashboardHours onChartClickHandler={props.onChartClickHandler} />
            </Grid>
            {/* ********WorkFlow Graph******* */}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container style={{ padding: 5, boxSize: 'none' }}>
                <WipDashboardWorkflow onChartClickHandler={props.onChartClickHandler} />
            </Grid>
            {/* ********* Return Reason By Workflow ********* */}
            <Grid item container xs={12} sm={12} xl={12} style={{ padding: 5, boxSize: 'none' }}>
                <WipDashboardReturnReason onChartClickHandler={props.onChartClickHandler} />
            </Grid>
            {/* *************Jobs By Technicians*************ss */}
            <Grid item container xs={12} sm={12} md={12} lg={12} xl={12} style={{ padding: 5, boxSize: 'none' }}>
                <WipDashboardTechnician />
            </Grid>
        </Grid>
    );
};

const Screen = (props) => {
    return (
        <EWipDashProvider {...props}>
            <DashboardCharts {...props} />
        </EWipDashProvider>
    );
};
export default Screen;
